import { createBrowserClient } from '@supabase/ssr'

// Função para criar cliente Supabase no Browser/Client Components
export function createSupabaseBrowserClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  )
}

// Cliente singleton para uso em componentes
let supabaseBrowserClient: ReturnType<typeof createSupabaseBrowserClient> | null = null

export function getSupabaseBrowserClient() {
  if (!supabaseBrowserClient) {
    supabaseBrowserClient = createSupabaseBrowserClient()
  }
  return supabaseBrowserClient
} 